module.exports = __webpack_public_path__ + "img/location.4e19f1f7.svg";